<div id="backdrop" class="modal-backdrop" [ngClass]="{ show: showModal }" style="z-index: 900"></div>
<div class="modal d-block fade" 
  [ngClass]="{ show: showModal }"
  id="listing-dialog" 
  tabindex="-1" role="dialog" aria-labelledby="modalIdLabel">
    <div class="modal-dialog mw-100" style="width: 60%; margin-top: 50px" role="document" (click)="onDialogClick($event)">
        <div class="modal-content">
            <div class="modal-header">
                <h5 *ngIf="showModal"><strong>Abwesenheit</strong></h5>
                <button type="button"
                    class="close"
                    (click)="goBack()"
                    aria-label="Close"><span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">

         <form [formGroup]="teamForm" *ngIf="teamForm" class="px-10" (submit)="submit()">
           
            <div class="row">

                <div class="col-12">
            
                  <div class="row mb-1">
                

                    <!--div class="col">
                      <label for="formGroupExampleInput"><small>Grund</small></label>
                      <select class="form-control" id="absence_type" name="absence_type" formControlName="absence_type">
                        <option value="" disabled selected hidden>Bitte auswählen</option>
                        <option value="sickness">Krank</option>
                        <option value="not_available">Nicht Verfügbar</option>
                        <option value="vacation">Urlaub</option>
                        <option value="blocked">blockiert</option>
                      </select>
                    </div-->

                    <div class="col">
                      <select class="form-control" style="margin-top: 10px;"  [ngClass]="{ 'is-invalid': submitted && f['absence_type_id'].errors }" id="absence_type_id" name="absence_type_id" formControlName="absence_type_id">
                        <option [ngValue]="">bitte auswählen</option>
                        <option *ngFor="let absence of absenceList" [ngValue]="absence.id">{{absence.name}}</option>
                      </select>
                    </div>
                    
                    <div class="col">
                   
                      <mat-form-field appearance="outline" class="w-full mt-1">
                        <mat-label>Beginn</mat-label>
                        <input matInput [matDatepicker]="picker_start_date" id="start_date" name="start_date" formControlName="start_date">
                        <mat-datepicker-toggle matSuffix [for]="picker_start_date"></mat-datepicker-toggle>
                        <mat-datepicker #picker_start_date></mat-datepicker>
                      </mat-form-field>
                    </div>

                    <div class="col">
                     
                      <mat-form-field appearance="outline" class="w-full mt-1">
                        <mat-label>Ende</mat-label>
                        <input matInput [matDatepicker]="picker_end_date" id="end_date" name="end_date" formControlName="end_date">
                        <mat-datepicker-toggle matSuffix [for]="picker_end_date"></mat-datepicker-toggle>
                        <mat-datepicker #picker_end_date></mat-datepicker>
                      </mat-form-field>
                    </div>

          
                  
                    <!--div class="col">
                      <div class="border-right: 0px solid #000;">
                        <mat-form-field appearance="outline" class="w-full">
                          <mat-label>Enter a date range</mat-label>
                          <mat-date-range-input [formGroup]="range" [rangePicker]="picker">
                            <input matStartDate formControlName="start_date" placeholder="Start date">
                            <input matEndDate formControlName="end_date" placeholder="End date">
                          </mat-date-range-input>
                          <mat-hint>MM/DD/YYYY – MM/DD/YYYY</mat-hint>
                          <mat-datepicker-toggle matSuffix [for]="picker3"></mat-datepicker-toggle>
                          <mat-date-range-picker #picker3></mat-date-range-picker>
                        
                          <mat-error *ngIf="range.controls.start.hasError('matStartDateInvalid')">Invalid start date</mat-error>
                          <mat-error *ngIf="range.controls.end.hasError('matEndDateInvalid')">Invalid end date</mat-error>
                        </mat-form-field>
                      
                      </div>
                    </div-->


                 
                 

             
                  </div>

    

                  <div class="row mb-1">
                    <div class="col">
                      <label for="formGroupExampleInput"><small>Notizen</small></label>
                      <input type="text" class="form-control" id="note" name="note" formControlName="note">
                    </div>
                  </div>   
              </div>   
            </div>
          <br>
            


            

            <button type="submit" class="btn btn-success">speichern</button>
            <!--button type="button" class="btn btn-success ml-1" (click)="addDummyData()">add dummydata</button-->
          </form>

</div>
<div class="modal-footer">
  <button type="button" class="btn btn-danger" (click)="delete()">löschen</button>
  <button type="button" class="btn btn-primary" (click)="goBack()">schließen</button>
</div>
</div>
</div>
</div>


